export const startPipelineMutation = /* GraphQL */ `
  mutation startPipeline($deviceID: String!, $analysisStartDate: String!, $analysisEndDate: String!) {
    startPipeline(deviceID: $deviceID, analysisStartDate: $analysisStartDate, analysisEndDate: $analysisEndDate) {
      createdDate
      pipelineExecutionID
      status
      pipelineID
      pipelineName
    }
  }
`;

export const saveLinesMutation = /* GraphQL */ `
  mutation saveLines($deviceID: String!, $lines:  [LineInput!]!) {
    saveLines(deviceID: $deviceID, lines: $lines) {
      name
    }
  }
`;


export const startCSVDownloadMutation = /* GraphQL */ `
  mutation startCSVDownload($deviceID: String!, $jobID: String!) {
    startCSVDownload(deviceID: $deviceID, jobID: $jobID) {
      url
    }
  }
`;